import React, { useEffect, useState } from 'react'
import './_styles/timesheetapp.scss'
import Root from './Pages/Root'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import posthog from 'posthog-js'
import SessionStore from './State/SessionStore'
import useVisible from './visibleHook'
import { authClient } from './lib/auth-client'
import { Providers } from './lib/providers'

const isDev = process.env.REACT_APP_ENV === 'development'

posthog.init('phc_Burb304xExjYSqj20cLeUVWCO2DfMIZqELYlfzC89i6', {
	api_host: isDev ? 'https://app.posthog.com' : 'https://hog.coincraft.co',
	ui_host: 'https://app.posthog.com',
	session_recording: {
		maskAllInputs: false,
	},
	capture_exceptions: !isDev, // Disable error tracking in development
	autocapture: !isDev, // Disable automatic event capturing in development
})

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			useErrorBoundary: true,
			suspense: true,
			staleTime: 0, //5 * 60 * 1000, // 5 minutes
			refetchOnWindowFocus: false, // default: true
		},
	},
})

function App() {
	const visibilityState = useVisible()
	useEffect(() => {
		SessionStore.checkIfUpdateIsAvailable()
	}, [visibilityState])

	return (
		<QueryClientProvider client={queryClient}>
			<Providers>
				<Root />
			</Providers>
		</QueryClientProvider>
	)
}

export default App
